import { ref } from '@vue/composition-api'

export default () => {
  const sortBy = ref('created_on')

  const setSortBy = (newSortBy) => (sortBy.value = newSortBy)

  const sortDesc = ref(true)

  const toggleSortDesc = () => (sortDesc.value = !sortDesc.value)

  const sortDirection = ref('asc')

  const toggleSortDirection = () =>
    (sortDirection.value = 'asc' === sortDirection.value ? 'desc' : 'asc')

  return {
    sortBy,
    setSortBy,

    sortDesc,
    toggleSortDesc,

    sortDirection,
    toggleSortDirection
  }
}
